import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from './config';

const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [inquiries, setInquiries] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/api/users`);
        setUsers(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchInquiries = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/api/inquiries`);
        setInquiries(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchUsers();
    fetchInquiries();
  }, []);

  return (
    <div>
      <h2>Admin Panel</h2>
      <div>
        <h3>Registered Users</h3>
        <ul>
          {users.map(user => (
            <li key={user._id}>{user.name} ({user.email})</li>
          ))}
        </ul>
      </div>
      <div>
        <h3>Inquiries</h3>
        <ul>
          {inquiries.map(inquiry => (
            <li key={inquiry._id}>
              {inquiry.name} ({inquiry.email}) - {inquiry.category}: {inquiry.message}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminPanel;
